import { Route, Routes } from "react-router-dom";

import { ApplyPage } from "./candidate/apply/ApplyPage";
import { ConsentPage } from "./candidate/ConsentPage";
import { Landing } from "./candidate/Landing";
import { OAuthConsentPage } from "./candidate/oauth/OAuthConsentPage";
import { SignInError } from "./candidate/SignInError";
import { ThinkingPage } from "./candidate/thinking/ThinkingPage";
import { Layout } from "./layout/Layout";
import { NotFound } from "./NotFound";
import { CandidatePage } from "./review/CandidatePage";
import { ReviewHome } from "./review/ReviewHome";

export function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Landing />} />
        <Route path="/consent" element={<ConsentPage />} />
        <Route path="/signin-error" element={<SignInError />} />
        <Route path="/apply" element={<ApplyPage />} />
        <Route path="/thinking" element={<ThinkingPage />} />
        <Route path="/oauth/consent" element={<OAuthConsentPage />} />
        <Route path="/review" element={<ReviewHome />} />
        <Route path="/review/:publicId" element={<CandidatePage />} />
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
}
